<div id="PrintSlip_Modal" class="ui modal" id="PrintSlip_Modal" style="width: 100%; font-family: 'Arial'">
  <div class="ui modal" id="PrintSlip_Modal" style="width: 274px; font-family: 'Arial'">
    <div>
      <table class="PrintSlip_Table_Class_Original" style="width: 100%; border: 0; border-spacing: 0px">
        <tr>
          <td colspan="4">
            <div style="text-align: center"></div>
          </td>
        </tr>
        <tr>
          <td class="PrintSlip_Ticket" colspan="4">
            <img style="width: 100%; height: 75px" src="https://d3qlgrav8cpjr0.cloudfront.net/bet500/online-terminal/assets/images/terminalPeru/logo.png" />
          </td>
        </tr>
        <tr>
          <td colspan="4" style="padding-top: 20px; font-size: 12px; text-align: center; padding-bottom: 20px; font-family: 'Arial'; justify-content: center; display: flex">
            <!-- Terminnal Bilgileri gelecek -->
            <div style="width: 140px; display: flex; justify-content: center; align-items: center">
              {{ this.terminalInfo[0]?.BranhAddress }}
            </div>
          </td>
        </tr>

        <tr style="font-size: 18px; text-align: center; font-family: Arial; background-color: #000; color: #fff">
          <!-- Ticket Bilgileri gelecek -->
          <td class="PrintSlip_Ticket" colspan="4">
            <span>{{ slipId }}</span
            ><span> Contraseña (0)</span>
          </td>
        </tr>
      </table>
      <table class="PrintSlip_Table_Class_Original" style="width: 100%; border: 0">
        <tr>
          <td colspan="2" style="font-size: 12px; font-weight: bold; padding-bottom: 2px; font-family: 'Arial'">
            <span>Numero de Filial:</span>
          </td>
          <td colspan="2" style="padding-right: 12px; padding-left: 1px; text-align: right; padding-bottom: 2px; font-family: 'Arial'">
            <span style="font-size: 12px; font-weight: bold"> {{ this._UserHelper.customerUser.BranchId }}</span>
          </td>
        </tr>
        <tr>
          <td colspan="2" style="font-size: 12px; font-weight: bold; text-align: left; padding-bottom: 2px; font-family: 'Arial'">
            <span>Hora:</span>
          </td>
          <td colspan="2" style="padding-right: 14px; padding-left: 1px; text-align: right; padding-bottom: 2px; font-family: 'Arial'">
            <span style="font-size: 12px; font-weight: bold"> {{ slipInfo[0]?.CreateDateISO | dateFormat : 'dd.MM.yy HH:mm' }}</span>
          </td>
        </tr>
        <tr>
          <td colspan="2" style="font-size: 12px; font-weight: bold; text-align: left; padding-bottom: 2px; font-family: 'Arial'">
            <span>Monto por Apuesta:</span>
          </td>
          <td colspan="2" style="padding-right: 14px; padding-left: 1px; text-align: right; padding-bottom: 2px; font-family: 'Arial'">
            <span style="font-size: 12px; font-weight: bold">{{ slipInfo[0]?.Bets }}*{{ slipInfo[0]?.SlipStatu }} </span>
          </td>
        </tr>
      </table>

      <table class="PrintSlip_Table_Class_Original" style="width: 100%; border: 0">
        <tr>
          <td colspan="4" style="font-weight: bold; font-size: 12px; padding-bottom: 0px; font-family: 'Arial'; padding-bottom: 10px; padding-top: 10px">
            <span>Tipp:</span><span>{{ slipInfo[0]?.SlipType }}</span>
          </td>
        </tr>
        <ng-container *ngFor="let slipEvent of this._DataHelper.oldCouponList.reverse() | groupByEventName; first as isFirst">
          <tr>
            <td colspan="7" style="border-bottom: 2px solid #313131"></td>
          </tr>
          <tr>
            <td colspan="1" style="font-size: 12px; font-weight: bold; width: 30%; padding-bottom: 2px; font-family: 'Arial'">169CDE</td>

            <td colspan="4" style="font-size: 12px; font-weight: bold; padding-bottom: 2px; font-family: 'Arial'">
              {{ slipEvent.HomeTeam }}
            </td>
          </tr>
          <tr>
            <td class="PrintSlip_MatchDate" colspan="1" style="font-size: 12px; padding-bottom: 2px; width: 30%; font-family: 'Arial'">
              {{ (slipEvent.EventDateLong | dateFormat : 'dd-MM') == (this.today | dateFormat : 'dd-MM') ? ('today' | t) : (slipEvent.EventDateLong | dateFormat : 'dd.MM') }}
              {{ slipEvent.EventDateLong | dateFormat : 'H:mm' }}
            </td>

            <td colspan="4" style="font-size: 12px; font-weight: bold; padding-bottom: 2px; font-family: 'Arial'">{{ slipEvent.AwayTeam }}</td>
          </tr>
          <tr *ngFor="let slipCurrent of slipEvent?.eEvents">
            <td class="PrintSlip_Tipp" colspan="1" style="font-size: 12px; padding-bottom: 2px; font-family: 'Arial'; width: 30%">
              <span>{{ slipCurrent.OddsType }} </span>
            </td>
            <td colspan="2"></td>
            <td colspan="1" style="font-size: 12px; font-weight: bold; width: 15%; padding-bottom: 2px; font-family: 'Arial'">
              {{ slipCurrent.SpecialBetValue }}
            </td>
            <td colspan="1" style="font-size: 12px; font-weight: bold; text-align: right; width: 20%; padding-bottom: 2px; padding-right: 14px; font-family: 'Arial'">
              {{ slipCurrent.OutCome }}
            </td>
            <td colspan="1" style="font-size: 12px; font-weight: bold; text-align: right; width: 20%; padding-bottom: 2px; padding-right: 14px; font-family: 'Arial'">
              {{ slipCurrent.OddValue1 }}
            </td>
          </tr>
        </ng-container>
      </table>
      <table class="PrintSlip_Table_Class_Original" style="width: 100%; border: 0">
        <tr>
          <td colspan="7" style="border-top: 2px solid #313131"></td>
        </tr>
        <tr>
          <td colspan="1" style="font-weight: bold; font-size: 18px; padding-bottom: 0px; font-family: 'Arial'; width: 88%">
            <span>Monto:</span>
          </td>
          <td colspan="1"></td>
          <td colspan="2" style="font-weight: bold; font-size: 18px; padding-bottom: 0px; font-family: 'Arial'">
            <span>{{ slipInfo[0]?.Amount }}</span>
          </td>
          <td style="font-weight: bold; font-size: 18px; padding-bottom: 0px; font-family: 'Arial'">{{ this._UserHelper.customerUser.Symbol }}</td>
        </tr>
        <tr>
          <td colspan="1" style="font-weight: bold; font-size: 12px; padding-bottom: 0px; font-family: 'Arial'; width: 88%">
            <span>Cuota Tatal:</span>
          </td>
          <td colspan="1"></td>
          <td colspan="2" style="font-weight: bold; font-size: 12px; padding-bottom: 0px; font-family: 'Arial'">
            <span>{{ slipInfo[0]?.TotalOddValue }}</span>
          </td>
          <td colspan="1"></td>
        </tr>
        <tr>
          <td colspan="1" style="font-weight: bold; font-size: 18px; padding-bottom: 0px; font-family: 'Arial'; width: 88%">
            <span>Pago Máximo:</span>
          </td>
          <td colspan="1"></td>
          <td colspan="2" style="font-weight: bold; font-size: 18px; padding-bottom: 0px; font-family: 'Arial'">
            <span>{{ slipInfo[0]?.PosibbleGain }}</span>
          </td>
          <td colspan="1" style="font-weight: bold; font-size: 18px; padding-bottom: 0px; font-family: 'Arial'">{{ this._UserHelper.customerUser.Symbol }}</td>
        </tr>
      </table>

      <table class="PrintSlip_Table_Class_Original" style="width: 100%; border: 0">
        <tr>
          <td colspan="4" style="padding-top: 8px; font-family: 'Arial'">
            <div style="margin-top: 10px" class="barcode-box">
              <ngx-barcode
                [bc-value]="data.barcode"
                [bc-line-color]="lineColor"
                [bc-width]="width"
                [bc-height]="height"
                [bc-display-value]="displayValue"
                [bc-font-options]="fontOptions"
                [bc-font]="font"
                [bc-text-align]="textAlign"
                [bc-text-position]="textPosition"
                [bc-text-margin]="textMargin"
                [bc-font-size]="fontSize"
                [bc-background]="background"
                [bc-margin]="margin"
                [bc-margin-top]="marginTop"
                [bc-margin-bottom]="marginBottom"
                [bc-margin-left]="marginLeft"
                [bc-margin-right]="marginRight">
              </ngx-barcode>
            </div>
          </td>
        </tr>
      </table>

      <table>
        <tr>
          <td colspan="4" style="font-size: 20px; font-family: 'Arial'">
            <div style="line-height: 14px; padding-right: 20px"></div>
          </td>
        </tr>
        <tr>
          <td colspan="4" style="font-size: 16px; font-family: 'Arial'">
            <br />
            <!-- <div style="line-height: 16px">Los boletos se pagan en la sede donde realizo la apuesta.</div>
            <div style="line-height: 16px">Solo se pagan boletos originales y en buen estado.</div>
            <div style="line-height: 16px">La vigencia de pago es de 30 días.</div>
            <div style="line-height: 16px">GRACIAS POR SU PREFERENCIA</div> -->
            {{ this.terminalInfo[0]?.CompAddress }}
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>
